import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createSetTransactionCategoriesDataAction,
} from "../../../../actions/dataActions";
import {getTransactionReportingCategoriesData} from "../../../../state/selectors";
import { Box, Table, Title } from "@allxsmith/bestax-bulma";
import NewTransactionReportingCategory from "./NewTransactionReportingCategory";
import TransactionReportingCategoryRow from "./TransactionReportingCategoryRow";

function TransactionReportingCategoryView(props) {
  const dispatch = useDispatch();
  // const dataFresh = useSelector(getDataFresh);


  const onTransactionReportingCategoryUpdate = (index, newTransactionReportingCategory) => {
    let newState = data;
    newState.results[index] = newTransactionReportingCategory;
    dispatch(createSetTransactionCategoriesDataAction(newState));
  };

  // const complete = useTransactionReportingCategoryData({ page }, dataFresh);
  const data = useSelector(getTransactionReportingCategoriesData);

  // if (!complete) {
  //   return (
  //     <Box>
  //       <Spinner
  //         className="spinner-centre"
  //         size={120}
  //         spinnerColor={"#3273dc"}
  //         spinnerWidth={2}
  //       />
  //     </Box>
  //   );
  // }

  return (
    <div>
      <NewTransactionReportingCategory />
      <Box>
        <Title>Transaction Reporting Category</Title>
          <Title size="6">
            Note: Modifying these values will update the transaction categories of existing
            transactions!
          </Title>
          <Table>
            <thead>
              <tr>
                <th>Transaction Category</th>
                <th>Hide</th>
              </tr>
            </thead>
            <tbody>
              {data.results.map((value, index) => (
                <TransactionReportingCategoryRow
                  key={value.id}
                  transactionReportingCategoryData={value}
                  index={index}
                  endpoint={props.endpoint} onTransactionReportingCategoryUpdate={onTransactionReportingCategoryUpdate}
                />
              ))}
            </tbody>
          </Table>
      </Box>
    </div>
  );
}

export default TransactionReportingCategoryView;
